"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defer = exports.default = exports.debounce = void 0;
exports.filterMap = filterMap;
exports.throttle = exports.noop = void 0;
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _lodash2 = _interopRequireDefault(require("lodash.defer"));
var _lodash3 = _interopRequireDefault(require("lodash.throttle"));
var debounce = _lodash.default;
exports.debounce = debounce;
var defer = _lodash2.default;

exports.defer = defer;
function filterMap(array, filterFn, mapFn) {
  if (!(Array.isArray(array) && typeof filterFn === 'function' && typeof mapFn === 'function')) {
    throw new TypeError();
  }
  var len = array.length;
  var res = new Array(len);
  var c = 0;
  for (var i = 0; i < len; i++) {
    var _value = array[i];
    if (filterFn(array[i], i, array)) {
      res[c++] = mapFn(_value, i, array);
    }
  }
  res.length = c;
  return res;
}
var noop = () => {};
exports.noop = noop;
var throttle = _lodash3.default;
exports.throttle = throttle;
var _default = {
  debounce,
  defer,
  filterMap,
  noop,
  throttle
};
exports.default = _default;